import React, { useState } from "react";
import { ReadMoreContainer, StyledButton } from "./styled";

import { SystemIcon } from "@storeblocks/icon";
import CollapsibleContainer from "Components/CollapsibleContainer";
import { Description } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/coverages.styles";
import { stbColors } from "Components/Themes/Storebrand/storebrandColors";
import { buttonTrackId } from "Utils/analytics";
import { createKey } from "Utils/generalUtils";
import { ReadMoreProps } from "./interfaces";

export const ReadMore = ({
  title,
  buttonName,
  children,
}: React.PropsWithChildren<ReadMoreProps>): React.ReactElement => {
  const [titleId] = useState(createKey());
  const [containerid] = useState(createKey());
  const [open, setOpen] = useState(false);

  const handleOpen = (): void => {
    setOpen(!open);
  };

  return (
    <ReadMoreContainer>
      <Description id={titleId} fw={400} size="16px">
        {title}
        <StyledButton
          id="button-autorization-read-more"
          trackId={buttonTrackId("autorization-read-more")}
          type="button"
          variant="text"
          onClick={handleOpen}
          color={stbColors.stbRed}
          aria-controls={containerid}
          aria-expanded={open}
        >
          {buttonName}
          <SystemIcon
            marginLeft="8px"
            name={open ? "chevron-up" : "chevron-down"}
          />
        </StyledButton>
      </Description>
      <CollapsibleContainer
        id={containerid}
        isOpen={open}
        aria-labelledby={titleId}
      >
        {children}
      </CollapsibleContainer>
    </ReadMoreContainer>
  );
};
